import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  private router = inject(Router);
  headLess = false;

  constructor() {
    const segments = this.router.url.split('/');
    this.headLess = segments.indexOf('headless') != -1;
  }

  year: number = new Date().getFullYear();
}
